import { customerBaseApi } from "@/react/services/api/api";
import { tenantsBaseUrl } from "@/react/features/vcc/urls";
import { HttpMethods } from "@/react/http";

export const tenantApi = customerBaseApi.injectEndpoints({
  endpoints: (build) => ({
    getTenantAudioFiles: build.query({
      query: ({ tenantName }) => ({
        url: `${tenantsBaseUrl(tenantName)}/audio-files`,
        method: HttpMethods.GET,
      }),
    }),
  }),
});

export const { useGetTenantAudioFilesQuery } = tenantApi;
